"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _dashboard = _interopRequireDefault(require("./dashboard"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Header = _antd.Layout.Header,
  Content = _antd.Layout.Content;
var menuItems = [{
  label: '主页',
  key: 'dashboard',
  icon: /*#__PURE__*/_react.default.createElement(_icons.HomeOutlined, null)
}, {
  label: '表单页',
  key: 'form',
  icon: /*#__PURE__*/_react.default.createElement(_icons.FormOutlined, null)
}, {
  label: '项目',
  key: 'project',
  icon: /*#__PURE__*/_react.default.createElement(_icons.ProjectOutlined, null),
  children: [{
    label: '列表页',
    key: 'table',
    icon: /*#__PURE__*/_react.default.createElement(_icons.DatabaseOutlined, null)
  }, {
    label: '详情页',
    key: 'detail',
    icon: /*#__PURE__*/_react.default.createElement(_icons.ContainerOutlined, null)
  }, {
    label: '结果页',
    key: 'result',
    icon: /*#__PURE__*/_react.default.createElement(_icons.SafetyCertificateOutlined, null)
  }]
}];
var AppDemo = function AppDemo(_ref) {
  var className = _ref.className,
    style = _ref.style;
  var _theme$useToken = _antd.theme.useToken(),
    token = _theme$useToken.token;
  return /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: {
      components: {
        Layout: {
          colorBgHeader: token.colorBgLayout
        },
        Menu: {
          colorItemBg: token.colorBgLayout,
          colorItemTextSelected: token.colorText,
          colorItemBgSelected: token.colorPrimaryBgHover
        }
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Layout, {
    className: className,
    style: _objectSpread({}, style)
  }, /*#__PURE__*/_react.default.createElement(Header, {
    style: {
      padding: '0 24px',
      display: 'flex',
      borderBottom: "1px solid ".concat(token.colorSplit)
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Ant Design Pro",
    src: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
    style: {
      width: 30,
      height: 30
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginLeft: 8,
      fontSize: token.fontSizeLG,
      fontWeight: token.fontWeightStrong
    }
  }, "Ant Design Pro")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, {
      style: {
        fontSize: token.fontSizeIcon
      }
    }),
    type: "text",
    style: {
      marginLeft: token.marginXS
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.BellOutlined, {
      style: {
        fontSize: token.fontSizeIcon
      }
    }),
    type: "text",
    style: {
      marginLeft: token.marginXS
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, {
      style: {
        fontSize: token.fontSizeIcon
      }
    }),
    type: "text",
    style: {
      marginLeft: token.marginXS
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    src: "https://gw.alipayobjects.com/mdn/rms_08e378/afts/img/A*CLp0Qqc11AkAAAAAAAAAAAAAARQnAQ",
    style: {
      marginLeft: token.marginSM
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: '0 0 208px'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    defaultOpenKeys: ['project'],
    mode: "inline",
    style: {
      height: '100%',
      paddingTop: 4
    },
    items: menuItems
  })), /*#__PURE__*/_react.default.createElement(_antd.Layout, null, /*#__PURE__*/_react.default.createElement(Content, {
    style: {
      padding: 24,
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_dashboard.default, null))))));
};
var _default = exports.default = AppDemo;